(() => {
  'use strict';

  const icons = {
    heart: {
      label: 'Heart',
      svg: '<path d="M300 230C252 195 226 171 226 137c0-28 21-49 49-49 17 0 32 8 41 21 9-13 24-21 41-21 28 0 49 21 49 49 0 34-26 58-74 93l-16 12-16-12Z" fill="none" stroke="currentColor" stroke-width="8" stroke-linejoin="round"/>'
    },
    star: {
      label: 'Star',
      svg: '<path d="M300 82l25 62 67 4-52 43 17 65-57-36-57 36 17-65-52-43 67-4 25-62Z" fill="none" stroke="currentColor" stroke-width="8" stroke-linejoin="round"/>'
    },
    rings: {
      label: 'Wedding rings',
      svg: '<circle cx="278" cy="180" r="58" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="322" cy="180" r="58" fill="none" stroke="currentColor" stroke-width="8"/>'
    },
    flower: {
      label: 'Flower',
      svg: '<g fill="none" stroke="currentColor" stroke-width="7"><circle cx="300" cy="180" r="22"/><ellipse cx="300" cy="118" rx="25" ry="42"/><ellipse cx="300" cy="242" rx="25" ry="42"/><ellipse cx="238" cy="180" rx="42" ry="25"/><ellipse cx="362" cy="180" rx="42" ry="25"/><ellipse cx="256" cy="136" rx="24" ry="39" transform="rotate(-45 256 136)"/><ellipse cx="344" cy="224" rx="24" ry="39" transform="rotate(-45 344 224)"/><ellipse cx="344" cy="136" rx="24" ry="39" transform="rotate(45 344 136)"/><ellipse cx="256" cy="224" rx="24" ry="39" transform="rotate(45 256 224)"/></g>'
    },
    cross: {
      label: 'Cross',
      svg: '<path d="M278 82h44v68h64v44h-64v92h-44v-92h-64v-44h64V82Z" fill="none" stroke="currentColor" stroke-width="8" stroke-linejoin="round"/>'
    },
    laurel: {
      label: 'Laurel wreath',
      svg: '<g fill="none" stroke="currentColor" stroke-width="7" stroke-linecap="round"><path d="M274 270c-57-36-83-92-63-151"/><path d="M326 270c57-36 83-92 63-151"/><path d="M229 230l-31-5M216 202l-29-14M207 171l-24-22M208 140l-18-29M371 230l31-5M384 202l29-14M393 171l24-22M392 140l18-29"/></g>'
    },
    paw: {
      label: 'Paw print',
      svg: '<g fill="none" stroke="currentColor" stroke-width="8"><ellipse cx="300" cy="220" rx="58" ry="48"/><ellipse cx="248" cy="151" rx="24" ry="32" transform="rotate(-25 248 151)"/><ellipse cx="286" cy="126" rx="23" ry="31"/><ellipse cx="326" cy="126" rx="23" ry="31"/><ellipse cx="364" cy="151" rx="24" ry="32" transform="rotate(25 364 151)"/></g>'
    },
    camera: {
      label: 'Camera',
      svg: '<g fill="none" stroke="currentColor" stroke-width="8" stroke-linejoin="round"><rect x="210" y="126" width="180" height="120" rx="18"/><path d="M250 126l18-31h64l18 31"/><circle cx="300" cy="186" r="38"/></g>'
    }
  };

  const templates = {
    wedding: { text: 'ALEX & JORDAN\n06.20.2026', fontSize: 30, icon: icons.rings },
    monogram: { text: 'A G', fontSize: 56, icon: icons.laurel },
    memorial: { text: 'Forever in our hearts\nIn loving memory', fontSize: 28, icon: icons.heart },
    business: { text: 'SCAN TO CONNECT', fontSize: 27, icon: null }
  };

  const init = (root) => {
    if (!root || root.dataset.ufLibrary602Ready === 'true') return;
    const designer = root.querySelector('[data-uf-designer]');
    if (!designer) return;
    root.dataset.ufLibrary602Ready = 'true';

    designer.querySelectorAll('[data-uf-library-icon]').forEach((button) => {
      button.addEventListener('click', () => {
        const icon = icons[button.dataset.ufLibraryIcon];
        if (!icon) return;
        designer.dispatchEvent(new CustomEvent('uf:add-library-icon', { detail: { ...icon, key: button.dataset.ufLibraryIcon } }));
      });
    });

    designer.querySelectorAll('[data-uf-library-template]').forEach((button) => {
      button.addEventListener('click', () => {
        const template = templates[button.dataset.ufLibraryTemplate];
        if (!template) return;
        designer.dispatchEvent(new CustomEvent('uf:apply-design-template', { detail: template }));
      });
    });
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-uf-personalization-side]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true }); else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
